import { useCallback, useEffect, useMemo } from 'react';
import { getThumbnail } from 'utils/api/instagram.api';
import { useQuery } from 'react-query';

export function useInstagramThumbnail(url) {
    const shortcode = url?.match(/\/p\/([A-Za-z0-9_-]+)/)?.[1];

    const queryFn = useCallback(async () => {
        if (!shortcode) return null;
        return await getThumbnail(shortcode);
    }, [shortcode]);

    const thumbnailQuery = useQuery({
        queryKey: ['instagram-thumbnail', shortcode],
        queryFn,
        enabled: !!shortcode,
        cacheTime: 60 * 60 * 1000,
        staleTime: 60 * 60 * 1000,
        retry: (failureCount, error) => {
            if (error?.status === 404) return false;
            return failureCount < 2;
        },
    });

    const thumbnailUrl = useMemo(() => {
        if (!thumbnailQuery.data) return null;
        return URL.createObjectURL(thumbnailQuery.data);
    }, [thumbnailQuery.data]);

    useEffect(() => {
        const currentUrl = thumbnailUrl;
        return () => {
            if (currentUrl) URL.revokeObjectURL(currentUrl);
        };
    }, [thumbnailUrl]);

    return {
        thumbnailUrl,
        isLoading: thumbnailQuery.isLoading,
        isError: thumbnailQuery.isError,
    };
}

export default useInstagramThumbnail;
